import namespacedSelector from '../helpers/selectors/namespacedSelector'

const selector = namespacedSelector('serviceWorker')

export const updateFound = selector('updateFound')
